import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `global.manage`,
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-regulation" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-regulation" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamentos',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                // props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                // props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Regulamentos',
        }
    },
    {
        path: `/${apiConstants.code}/atmospheretypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-atmospheretypes" */ './views/atmospheretype/AtmosphereTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.atmosphere_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-atmospheretypes" */ './views/atmospheretype/AtmosphereTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Condições Atmosféricas',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.atmosphere_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-atmospheretypes" */ './views/atmospheretype/AtmosphereTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Condição Atmosférica',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.atmosphere_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-atmospheretypes" */ './views/atmospheretype/AtmosphereTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Condição Atmosférica',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Condições Atmosféricas',
        }
    },
    {
        path: `/${apiConstants.code}/driveragetypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-driveragetypes" */ './views/driveragetype/DriverAgeTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.driver_age_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-driveragetypes" */ './views/driveragetype/DriverAgeTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Idades do Condutor',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.driver_age_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-driveragetypes" */ './views/driveragetype/DriverAgeTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Idade do Condutor',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.driver_age_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-driveragetypes" */ './views/driveragetype/DriverAgeTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Idade do Condutor',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Idades do Condutor',
        }
    },
    {
        path: `/${apiConstants.code}/luminositytypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-luminositytypes" */ './views/luminositytype/LuminosityTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.luminosity_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-luminositytypes" */ './views/luminositytype/LuminosityTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipos de Luminosidade',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.luminosity_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-luminositytypes" */ './views/luminositytype/LuminosityTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Luminosidade',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.luminosity_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-luminositytypes" */ './views/luminositytype/LuminosityTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Luminosidade',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Tipos de Luminosidade',
        }
    },
    {
        path: `/${apiConstants.code}/roadconservationstatetypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-roadconservationstatetypes" */ './views/roadconservationstatetype/RoadConservationStateTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.road_conservation_state_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-roadconservationstatetypes" */ './views/roadconservationstatetype/RoadConservationStateTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estados de Conservação',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.road_conservation_state_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-roadconservationstatetypes" */ './views/roadconservationstatetype/RoadConservationStateTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estado de Conservação',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.road_conservation_state_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-roadconservationstatetypes" */ './views/roadconservationstatetype/RoadConservationStateTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estado de Conservação',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Estados Conservação',
        }
    },
    {
        path: `/${apiConstants.code}/vehicletypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-vehicletypes" */ './views/vehicletype/VehicleTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.vehicle_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-vehicletypes" */ './views/vehicletype/VehicleTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipos de Veículo',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.vehicle_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-vehicletypes" */ './views/vehicletype/VehicleTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo de Veículo',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.vehicle_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-vehicletypes" */ './views/vehicletype/VehicleTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo de Veículo',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Tipos de Veículo',
        }
    },
    {
        path: `/${apiConstants.code}/accidenttypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidenttypes" */ './views/accidenttype/AccidentTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.accident_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidenttypes" */ './views/accidenttype/AccidentTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipos de Acidente',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.accident_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidenttypes" */ './views/accidenttype/AccidentTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo de Acidente',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.accident_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidenttypes" */ './views/accidenttype/AccidentTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo de Acidente',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Tipos de Acidente',
        }
    },
    {
        path: `/${apiConstants.code}/accidentyears`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidentyears" */ './views/accidentyear/AccidentYearBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.accident_years`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidentyears" */ './views/accidentyear/AccidentYearList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Anos',
                }
            },
            // {
            //     path: 'add',
            //     name: `${apiConstants.code}.accident_years.create`,
            //     props: true,
            //     component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidentyears" */ './views/accidentyear/AccidentYearDetails.vue'),
            //     meta: {
            //         auth: undefined,
            //         hideHeaderName: true,
            //         title: 'Ano',
            //     }
            // },
            {
                path: ':id',
                name: `${apiConstants.code}.accident_years.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pspgestao-accidentyears" */ './views/accidentyear/AccidentYearDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Ano',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Anos',
        }
    },
];

export default routes;